<template>
  <div>
    <div class="hm-headline">
      <span class="headline">充值管理</span>
      <span class="subhead">充值记录</span>
    </div>
    <el-card>
      <div class="flex panel-header flex-end">
        <div class="flex flex-wrap">
          <el-date-picker
            size="small"
            class="mr10"
            style="width: 250px;"
            value-format="yyyy-MM-dd"
            v-model="time"
            type="daterange"
            range-separator="至"
            start-placeholder="充值时间"
            end-placeholder="充值时间"
          >
          </el-date-picker>
          <el-select
            size="small"
            clearable
            class="mr10"
            style="width: 150px;"
            placeholder="选择导购"
            v-model="salesman"
            filterable
          >
            <el-option
              v-for="(item, i) in guiderList"
              :key="i"
              :label="item.guiderName"
              :value="item.salesman"
            >
            </el-option>
          </el-select>
          <el-select
            size="small"
            v-model="offlineStatus"
            placeholder="POS充值状态"
            class="mr10"
            style="width: 150px;"
            clearable
          >
            <el-option label="充值成功" value="1"></el-option>
            <el-option label="充值失败" value="0"></el-option>
          </el-select>
          <el-select
            size="small"
            v-model="status"
            placeholder="商户充值状态"
            class="mr10"
            style="width: 150px;"
            clearable
          >
            <el-option label="取消充值" value="0"></el-option>
            <el-option label="充值成功" value="1"></el-option>
            <el-option label="充值失败" value="2"></el-option>
          </el-select>
          <el-input
            size="small"
            placeholder="请输入流水号/手机号"
            clearable
            style="width: 150px;"
            class="mr10"
            v-model.trim="keyWord"
          ></el-input>
          <el-button
            size="small"
            @click="reset"
            class="mr10 hmicon icon-zhongzhi reset"
          ></el-button>
          <el-button
            size="small"
            type="primary"
            style="margin-left: 0"
            @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table border :data="rechargeRecord" style="width: 100%">
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="transaction_id"
            label="流水号"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="configName"
            label="面额"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="money"
            label="充值金额"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTimeFormat"
            label="充值时间"
            width="200"
          >
          </el-table-column>
          <!-- <el-table-column header-align="center" align="center"   label="到账时间" width="200">
            <template slot-scope="scope">
               <el-button size="small" type="text" @click="getRuleTime(scope.row.id)">{{scope.row.validTime}}</el-button>
            </template>
          </el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            label="POS充值状态"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.statusFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="商户充值状态"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.offlineStatusFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realName"
            label="充值用户"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="phoneNum"
            label="用户手机号"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guiderName"
            label="关联导购"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="text-right">
        <el-pagination
          background
          layout="total,  sizes,prev, pager, next, jumper"
          :total="rechargeRecordTotal"
          @current-change="paging"
          @size-change="handleSizeChange"
          :current-page="currentPage"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      time: [],
      salesman: "",
      offlineStatus: "",
      status: "",
      currentPage: 1
    };
  },

  components: {},

  created() {
    this.$store.dispatch("queryRechargeRecord", {
      pageNo: this.currentPage
    });
    this.$store.dispatch("queryGuiderByRechargeRecord");
  },

  computed: mapState({
    guiderList: state => state.recharge.guiderList,
    rechargeRecord: state => state.recharge.rechargeRecord,
    rechargeRecordTotal: state => state.recharge.rechargeRecordTotal
  }),

  methods: {
    reset() {
      this.salesman = "";
      this.status = "";
      this.startTime = "";
      this.endTime = "";
      this.keyWord = "";
      this.offlineStatus = "";
      this.time = "";
    },
    search() {
      this.currentPage = 1;
      this.$store.dispatch("queryRechargeRecord", {
        pageNo: this.currentPage,
        salesman: this.salesman,
        status: this.status,
        offlineStatus: this.offlineStatus,
        startTime: this.time && this.time.length > 0 ? this.time[0] : "",
        endTime: this.time && this.time.length > 0 ? this.time[1] : "",
        keyWord: this.keyWord
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.$store.dispatch("queryRechargeRecord", {
        pageNo: this.currentPage,
        salesman: this.salesman,
        status: this.status,
        offlineStatus: this.offlineStatus,
        startTime: this.time && this.time.length > 0 ? this.time[0] : "",
        endTime: this.time && this.time.length > 0 ? this.time[1] : "",
        keyWord: this.keyWord
      });
    },
    paging(page) {
      this.currentPage = page;
      this.$store.dispatch("queryRechargeRecord", {
        pageNo: this.currentPage,
        salesman: this.salesman,
        status: this.status,
        offlineStatus: this.offlineStatus,
        startTime: this.time && this.time.length > 0 ? this.time[0] : "",
        endTime: this.time && this.time.length > 0 ? this.time[1] : "",
        keyWord: this.keyWord
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  padding: 10px 0;
}
</style>
